export const isPrimitive = (test: any) => test !== Object(test);
